<!--
 * @Author: sunsan 2390864551@qq.com
 * @Date: 2023-11-05 20:50:59
 * @LastEditors: sunsan 2390864551@qq.com
 * @LastEditTime: 2023-11-07 22:06:11
 * @FilePath: \hopeEnroll\hope_enroll\src\App.vue
 * @Description: vue根组件
-->
<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script setup>
console.log('App.vue');
</script>

<style>
*{
  padding: 0;
  margin: 0;
}
</style>
